<div class="ui-kit title auth h1">
  <button (click)="doClick()">{{ button }}</button>
  <h1>{{ title | translate }}</h1>
</div>
